import {
    apiRequest,
    punishmentPeriodCreate
} from "../../../../../services/adapters/kepegawaian/hukdisService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", punishmentPeriodCreate, {
            body: query
        }, true)
    }


}

export default CreateRepository